export default "__VITE_ASSET__CqetyAkv__"